import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { IconButton, Drawer, List, ListItem, ListItemText } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

import { ThemeProvider } from '@material-ui/styles';

import theme from './theme.js';

const useStyles = makeStyles((theme) => ({
  list: {
    width: 250,
    marginTop:'40px',
  },
  fullList: {
    width: 'auto',
  },
}));

const CollapsedNavBar = (props) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
  });

  // toggle the drawer when click on the menu icon at the collapse state
  const toggleDrawer = (anchor) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: !state.top });
  };
  
  const closeDrawer = (anchor) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: false });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={closeDrawer(anchor)}
    >
    <ThemeProvider theme={theme}>
      <List>
        {props.navItems.map((navItem, index) => (
          <ListItem  id={index}
          button key={navItem.text}
          component={Link} to={navItem.link}>
            <ListItemText 
            primary={navItem.text}
            />
          </ListItem>
        ))}
        <ListItem button component='a' 
          target='blank' href={props.extLinks[1].link}>
            <ListItemText 
            primary={props.extLinks[1].text}
            />
          </ListItem>
      </List>
      </ThemeProvider>
    </div>
  );

  return (
    <div>
    {['top'].map((anchor) => (
      <React.Fragment key={anchor}>
        <IconButton edge="start" color="primary" onClick={toggleDrawer(anchor)}><MenuIcon /></IconButton>
        <Drawer anchor={anchor} open={state[anchor]} onClose={closeDrawer(anchor)}>
          {list(anchor)}
        </Drawer>
      </React.Fragment>
    ))}
    </div>
  );

}

export default (CollapsedNavBar);
